import React, { useContext } from 'react'

import PanelHeader from '../../../elem/panel/PanelHeader'
import MapHeaderControls from './MapHeaderControls'
import ExpandButton from '../../../elem/list/ExpandButton'
import CollapseButton from '../../../elem/list/CollapseButton'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'
import { DataContext } from './DataContext'

const ExplorerMapHeader = () => {
    const { isCollapsed, setCollapsed } = useContext(DataContext)
    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    return (
        <PanelHeader extraClass={`mapPanelHeader`}>
            <div className="mapHeaderText">Map</div>
            <div className="panelHeaderControls">
                <div className="panelHeaderIconWrapper">
                    <MapHeaderControls />
                    {isExpanded ? null : (
                        <CollapseButton
                            name={`Map`}
                            isCollapsed={isCollapsed}
                            setIsCollapsed={setCollapsed}
                        />
                    )}
                    <ExpandButton
                        name={`Map`}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                    />
                </div>
            </div>
        </PanelHeader>
    )
}

export default ExplorerMapHeader